module.exports = __webpack_public_path__ + "img/diners_club_greyscale.5370f4df.png";